import { Progress, Tag } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import * as R from "ramda";

const Percentage = styled.div`
  margin-bottom: 0;
`;

const Header = styled.div`
  display: flex;
  gap: 20px;
  font-weight: bold;
  border-bottom: 1px solid #00000024;
  padding-bottom: 0.5em;
  margin-bottom: 1.5em;

  .ant-tag {
    padding-inline: 15px;
    text-align: center;
  }
`;

const TestKey = {
  "5": "reliability-worcket",
  "6": "reliabilityEnglish-worcket"
};

const tagNames = {
  high: "aprobado",
  low: "desaprobado"
};

const colors = {
  high: "#53C819",
  low: "#F5242E"
};

const tagColors = R.cond([
  [R.equals(tagNames.high), R.always(colors.high)],
  [R.equals(tagNames.low), R.always(colors.low)]
]);

const resultColors = R.cond([
  [R.gte(75), R.always(colors.low)],
  [R.gte(100), R.always(colors.high)]
]);

export default function ReliabilityTest({
  testIdentifier,
  serviceCallResultData
}) {
  const { t } = useTranslation(["opportunity"]);
  const { score, status } = serviceCallResultData;
  const testKey = TestKey[testIdentifier];

  try {
    return (
      <>
        <Header>
          {t(`opportunity:process.candidateDetails.${testKey}.title`)}
          <Tag
            color={tagColors(status)}
            style={{ textTransform: "uppercase", margin: 0 }}
          >
            {t(`opportunity:process.candidateDetails.${testKey}.${status}`)}
          </Tag>
        </Header>
        <Percentage>
          <span>{`${t(
            `opportunity:process.candidateDetails.${testKey}.label`
          )} (${score}%)`}</span>
          <Progress
            percent={score || 1}
            showInfo={false}
            strokeColor={resultColors(score)}
          />
        </Percentage>
      </>
    );
  } catch (e) {
    console.error(e);
    return (
      <div>
        <p>{t("opportunity:process.candidateDetails.testVisualizeError")}</p>
      </div>
    );
  }
}
